import type { DependentEntityInfo } from "@common/types";
import type { WeightsSetDependenciesReadModel } from "@Criteria/Weights/Domain/readmodels";

export class WeightsSetDeleterViewModel
{
    isOpen = false;

    initialized = false;

    weightsSetId: number | null = null;
    weightsSetName = '';

    hasDependants = false;
    dependenciesCount = 0;

    weightedScores: DependentEntityInfo[] = [];

    show(weightsSetId: number, weightsSetName: string)
    {
        this.initialized = false;
        this.weightsSetId = weightsSetId;
        this.weightsSetName = weightsSetName;

        this.hasDependants = false;
        this.dependenciesCount = 0;
        this.weightedScores = [];

        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.reset();
    }

    setData(data: WeightsSetDependenciesReadModel)
    {
        this.hasDependants = data.HasDependants;
        this.dependenciesCount = data.DependenciesCount;
        this.weightedScores = data.WeightedScores;

        this.initialized = true;
    }

    private reset()
    {
        this.initialized = false;
        this.weightsSetId = null;
        this.weightsSetName = '';
        this.hasDependants = false;
        this.dependenciesCount = 0;
        this.weightedScores = [];
    }
}
